<div>
  <form (ngSubmit)="onSubmit()" (reset)="onReset()" [formGroup]="form" [class]="this.formClassName">
    @defer {
      <div class="max-h-[95%]">
        @for(field of fields; track field.key) {
          <lib-dynamic-form-field [field]="field" [form]="form" />
        }
      </div>
    } @loading (minimum 0.8s) {
      <div class="flex items-center justify-center h-80">
        <mat-spinner diameter="80"></mat-spinner>
      </div>
    }
    @if(buttons?.length) {
      <div class="sticky-footer sticky bottom-[0px]">
        @for(button of buttons; track button.key) {
          <lib-dynamic-form-field [field]="button" [form]="form" [class]="button.className" />
        }
      </div>
    }
  </form>
</div>